import gettext from '@eb/gettext';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class UnsubscribeConfirmationScreen extends PureComponent {
    static propTypes = {
        // Using redux so these props should be coming in from ConnectedUnsubscribeConfirmationScreen,
        // mapped from the Redux state & actions
        organizationName: PropTypes.string.isRequired,
    };

    render() {
        const { organizationName } = this.props;

        const unsubscribedText = gettext(
            "You've successfully unsubscribed from %(organizationName)s.",
            { organizationName },
        );
        const comeBackText = gettext("We'll miss you. Come back any time.");

        return (
            <div className="eds-g-grid eds-l-pad-vert-20">
                <div className="eds-g-group">
                    <div className="eds-g-cell eds-g-cell-md-1-2 eds-g-cell-1-1 eds-g-offset-md-0-1 eds-g-offset-sm-1-4">
                        <div className="eds-g-cell-md-1-1 eds-g-cell-sm-1-2">
                            <div
                                className="eds-text-hl"
                                data-spec="unsubscribed-text"
                            >
                                {unsubscribedText}
                            </div>
                            <hr
                                className="eds-bg-color--primary-brand eds-divider--horizontal eds-l-mar-vert-5 eds-l-mar-hor-0"
                                style={{
                                    width: '30px',
                                    height: '2px',
                                    border: '0',
                                }}
                            />
                            <div className="eds-text-bl">{comeBackText}</div>
                        </div>
                    </div>
                    <div className="eds-g-cell eds-g-cell-md-1-2 eds-g-cell-1-1 eds-l-mn-pad-top-10 eds-l-sw-pad-top-10 eds-l-sm-pad-top-10 eds-l-sn-pad-top-10">
                        <div className="eds-g-cell-1-1 eds-align--center">
                            <img
                                style={{
                                    maxWidth: 375,
                                    width: '100%',
                                    height: '100%',
                                }}
                                alt=""
                                src="https://cdn.evbstatic.com/s3-build/perm_001/46ddfc/django/images/organizations/unsubscribe_landing.png"
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
